// API for Agent Applications
// Saves to agent_applications table

import { supabaseAnon } from '../lib/supabase';

async function notifyAdmins(applicationId: string, data: AgentApplicationData) {
  try {
    await supabaseAnon.functions.invoke('notify-new-application', {
      body: { type: 'agent', applicationId, ...data },
    });
  } catch (e) {
    console.error('Admin notification failed (non-critical):', e);
  }
}

export interface AgentApplicationData {
  fullName: string;
  email: string;
  phone: string;
  instagram?: string;
  state: string;
  licenseStatus: string;
  experience: string;
  interviewDate: string;
  interviewTime: string;
  source: string;
  referralSource?: string;
}

export async function submitAgentApplication(data: AgentApplicationData): Promise<{ success: boolean; id?: string; error?: string }> {
  try {
    // Validation
    if (!data.fullName || !data.email || !data.phone || !data.state || !data.licenseStatus || !data.experience || !data.interviewDate || !data.interviewTime) {
      return { success: false, error: 'Required fields are missing' };
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(data.email)) {
      return { success: false, error: 'Invalid email format' };
    }

    // Insert into agent_applications table
    const { data: application, error } = await supabaseAnon
      .from('agent_applications')
      .insert({
        full_name: data.fullName,
        email: data.email,
        phone: data.phone,
        instagram: data.instagram || '',
        state: data.state,
        license_status: data.licenseStatus,
        experience: data.experience,
        interview_date: data.interviewDate,
        interview_time: data.interviewTime,
        source: data.source,
        referral_source: data.referralSource || '',
        status: 'pending',
      })
      .select('id')
      .single();

    if (error) {
      console.error('Supabase error:', error);
      
      if (error.code === '23505') {
        return { success: false, error: 'An application with this email already exists.' };
      }
      
      return { 
        success: false, 
        error: 'Failed to submit application. Please try again.' 
      };
    }

    console.log('Agent application submitted successfully:', application.id);

    notifyAdmins(application.id, data);

    return { 
      success: true, 
      id: application.id 
    };
    
  } catch (error) {
    console.error('Agent application submission error:', error);
    return { 
      success: false, 
      error: 'Internal server error. Please try again.' 
    };
  }
}
